import {
  LocalizedNewsPost,
  TranslationLanguage,
  TRANSLATION_LANGUAGES,
} from 'apollo/localizedTypes';

const hasText = (value?: string | null): boolean => Boolean(value && value.trim());

const getMissingTranslations = (newsPost: LocalizedNewsPost): TranslationLanguage[] => {
  return TRANSLATION_LANGUAGES.filter((language) => {
    if (!hasText(newsPost.title[language])) return true;
    if (!newsPost.contents || !newsPost.contents.length) return true;
    return newsPost.contents.some((item) => !hasText(item.content[language]));
  });
};

export default getMissingTranslations;
